export default "__VITE_ASSET__CUCdF68u__"